<div class="drawer drawer-end">
  <input
    id="gb-mobile-drawer"
    type="checkbox"
    class="drawer-toggle"
    [checked]="menuOpen"
    (change)="onDrawerToggle($event)"
  />

  <div class="drawer-content">
    <header
      class="navbar relative z-[1100] bg-base-100 shadow-sm py-1.5"
      [class.shadow-md]="ctx.route.headerShadow"
    >
      <div class="gb-charity-shell flex items-center">
        <!-- Logo: Givebrite on platform hosts; charity logo on charity hosts -->
        <div class="flex-shrink-0">
          <a [routerLink]="AppRoutes.home()" class="flex items-center">
            @if (isPlatformApp) {
              <img
                [src]="platformLogoSrc"
                alt="givebrite"
                class="h-10 max-w-[140px] w-auto object-contain select-none sm:h-12"
              />
            } @else if (ctx.charity?.logo?.color) {
              <img
                [src]="ctx.charity.logo.color"
                alt="{{ ctx.charity.name }} logo"
                class="h-16 max-w-[120px] w-auto object-contain select-none"
              />
            }
          </a>
        </div>

        <div class="flex-1"></div>

        @if (donatePage) {
          <div class="currency-selector mr-1 sm:mr-2">
            <ui-button
              id="currency"
              variant="ghost"
              size="sm"
              (buttonClick)="openCurrencySelector()"
            >
              @if (config$ | async; as config) {
                <span class="text-sm">{{ config.currency | currencySymbol }}</span>
                <span>{{ config.currency }}</span>
              }
              <ui-icon
                [name]="isOpenCurrencySelector ? 'chevron-up' : 'chevron-down'"
                [size]="14"
                class="text-base-content/60"
              ></ui-icon>
            </ui-button>

            <div class="currency-selector__panel">
              <app-multi-currency
                (onShowCurrencySelector)="currencySelector($event)"
              ></app-multi-currency>
            </div>
          </div>
        }

        <!-- Desktop nav + CTAs -->
        @if (ctx.responsive.isDesktop) {
          @switch (ctx.route.headerMode) {
            @case ('checkout') {
              <!-- Checkout mode: progress indicator -->
              <div class="flex items-center gap-2 text-sm">
                <span class="badge badge-primary badge-sm">1</span>
                <span>Amount</span>
                <span class="text-base-content/30">—</span>
                <span class="badge badge-ghost badge-sm">2</span>
                <span class="text-base-content/50">Details</span>
                <span class="text-base-content/30">—</span>
                <span class="badge badge-ghost badge-sm">3</span>
                <span class="text-base-content/50">Payment</span>
              </div>
            }
            @case ('create') {
              <!-- Create mode: no CTAs, just logo -->
            }
            @default {
              <!-- Default mode: nav links + CTAs -->
              <nav class="hidden md:flex items-center gap-1">
                <!-- Navigation items will be wired in migration phase -->
              </nav>

              <div class="ml-4">
                <gb-header-nav-actions
                  layout="inline"
                  [dashboardUrl]="dashboardUrl"
                ></gb-header-nav-actions>
              </div>
            }
          }
        }

        <!-- Mobile hamburger -->
        @if (ctx.responsive.isMobile) {
          <ui-button variant="ghost" shape="circle" (buttonClick)="toggleMobileDrawer()">
            <ui-icon name="menu" [size]="20"></ui-icon>
          </ui-button>
        }
      </div>
    </header>
  </div>

  <!-- Mobile drawer panel -->
  <div class="drawer-side z-50">
    <label for="gb-mobile-drawer" aria-label="close menu" class="drawer-overlay"></label>
    <div class="menu bg-base-200 text-base-content min-h-full w-72 p-4 flex flex-col">
      <div class="mb-6 px-2">
        @if (isPlatformApp) {
          <img
            [src]="platformLogoSrc"
            alt="givebrite"
            class="h-8 max-w-[140px] w-auto object-contain"
          />
        } @else if (ctx.charity?.logo?.color) {
          <img
            [src]="ctx.charity.logo.color"
            [alt]="ctx.charity.name"
            class="h-10 max-w-[120px] w-auto object-contain"
          />
        }
      </div>

      <gb-header-account-menu
        mode="drawer"
        [dashboardUrl]="dashboardUrl"
        [showUnauthenticatedCta]="false"
        (menuAction)="closeMobileDrawer()"
      ></gb-header-account-menu>

      <!-- Navigation items will be wired in migration phase -->
      <div class="mt-auto">
        <gb-header-nav-actions
          layout="stack"
          [showAccount]="false"
          signInLabel="Log in"
          [dashboardUrl]="dashboardUrl"
          (menuAction)="closeMobileDrawer()"
        ></gb-header-nav-actions>
      </div>
    </div>
  </div>
</div>
